module.exports = __webpack_public_path__ + "static/img/bind.fa38f71b.png";